import React from "react";

const TableSkeletonLoader = ({ columns = 6, rows = 5 }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200 bg-[#FFFFFF]">
            {Array.from({ length: columns }).map((_, index) => (
              <th key={index} className="text-left py-4 px-4">
                <div className="text-left py-4 px-4  bg-gray-200 rounded w-3/4 animate-pulse"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200 bg-[#FFFFFF]"
            >
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex} className="py-4 px-4">
                  {colIndex === 0 ? (
                    <div className="flex items-center">
                      <div className="h-10 w-10 flex-shrink-0 mr-3 bg-gray-200 rounded-full animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                    </div>
                  ) : colIndex === columns - 1 ? (
                    <div className="flex justify-end space-x-2">
                      <div className="h-8 w-8 bg-gray-200 rounded-lg animate-pulse"></div>
                      <div className="h-8 w-8 bg-gray-200 rounded-lg animate-pulse"></div>
                    </div>
                  ) : (
                    <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeletonLoader;